import authReducer from "./reducers";

export default authReducer;